import React from 'react';
import Skeleton from '@alfa-retail-react/components/skeleton';
import classNames from 'classnames';

import { WindowTypeName, windowTypeToClassName } from 'app/utils/useWindowType';
import 'app/component/skeleton/flexible/FlexibleSkeleton.less';

export interface FlexibleSkeletonProps {
    /**
     * Тип окна.
     */
    windowType: WindowTypeName;
    /**
     * CSS класс.
     */
    className?: string;
}

/**
 * Скелетон компонента поля.
 */
export const FlexibleSkeleton = (props: FlexibleSkeletonProps) => {
    const className = classNames(
        'flexibleSkeleton',
        props.className,
        windowTypeToClassName(props.windowType),
    );

    return <Skeleton className={className} visible animate />;
};
